/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindAgecComplianceStatsQueryResponse,
  FindAgecComplianceStatsQueryParams,
} from "../types/FindAgecComplianceStats.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findAgecComplianceStatsQueryKey = (
  params: FindAgecComplianceStatsQueryParams
) =>
  [
    { url: "/v1/product/find-agec-compliance-stats" },
    ...(params ? [params] : []),
  ] as const

export type FindAgecComplianceStatsQueryKey = ReturnType<
  typeof findAgecComplianceStatsQueryKey
>

/**
 * @summary Find agec compliance stats
 * {@link /v1/product/find-agec-compliance-stats}
 */
export async function findAgecComplianceStats(
  params: FindAgecComplianceStatsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindAgecComplianceStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-agec-compliance-stats`,
    params,
    ...requestConfig,
  })
  return res
}

export function findAgecComplianceStatsQueryOptions(
  params: FindAgecComplianceStatsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findAgecComplianceStatsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindAgecComplianceStatsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindAgecComplianceStatsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findAgecComplianceStats(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find agec compliance stats
 * {@link /v1/product/find-agec-compliance-stats}
 */
export function useFindAgecComplianceStats<
  TData = ResponseConfig<FindAgecComplianceStatsQueryResponse>,
  TQueryData = ResponseConfig<FindAgecComplianceStatsQueryResponse>,
  TQueryKey extends QueryKey = FindAgecComplianceStatsQueryKey,
>(
  params: FindAgecComplianceStatsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindAgecComplianceStatsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findAgecComplianceStatsQueryKey(params)

  const query = useQuery(
    {
      ...findAgecComplianceStatsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
